import React from 'react'

// components
import Typography from '@mui/material/Typography'

const EditPersonHeader = props => {
  const { account, season, person, personType } = props
  const { registrationStatus } = account || {}
  const { reupRequired } = registrationStatus || {}

  return (
    <Typography pb={4} variant='h2' align='center'>
      {reupRequired && season && !person.confirmed
        ? `Confirm ${personType} for ${season.year}`
        : `Edit ${personType}`}
    </Typography>
  )
}

export default EditPersonHeader
